<div style="background-color: #dedede;line-height: 0px;">
    <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
      <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
        <a (click)="goToPageLink(item)">
          {{ item }}
        </a>
      </li>
    </ol>
  </div>
  
  
  <mat-toolbar class="top_headerbar">
    <h6 class="show-title">{{showEditUsertxt}}</h6>
    <button class="more-btn-custom" mat-raised-button (click)="addDevice()">
      <i class="material-icons icon-layout-custom">add_circle</i><span class="m_l_5 mob_hide">Add New</span>
    </button>
  </mat-toolbar>
  
  <div fxLayoutAlign="center center" fxLayout="column" style="padding: 16px;" class="form_outer">

    <mat-form-field class="example-full-width" floatLabel="always">
      <input placeholder="Site name" matInput>
      <!-- <mat-placeholder class="placeholder">Site name</mat-placeholder> -->
    </mat-form-field>
  
  
    <mat-form-field class="example-full-width" floatLabel="always">
      <input placeholder="Site description" matInput>
      <!-- <mat-placeholder class="placeholder">Site description</mat-placeholder> -->
    </mat-form-field>
  

  
    <div class="btn-box">
      <button *ngIf="showSavebtn" mat-raised-button style="border-radius: 50px;" (click)="saveDevice()">Save</button>
      <button *ngIf="showUpdateBtn" mat-raised-button style="border-radius: 50px;" (click)="saveDevice()">Update</button>
      <button *ngIf="showSavebtn" mat-raised-button style="border-radius: 50px;" (click)="saveAndAddGroup()">Save and add site groups</button>
      <button *ngIf="showUpdateBtn" mat-raised-button style="border-radius: 50px;" (click)="saveAndAddGroup()">Update site groups</button>
    </div>
  
  
  </div>